export const autoSuggestTheme = {
  borderColor: '--medkit-autosuggest-border-color',
  descriptionColor: '--medkit-autosuggest-description-color',
  dividerColor: '--medkit-autosuggest-divider-color',
  labelColor: '--medkit-autosuggest-label-color',
  spinnerColor: '--medkit-autosuggest-spinner-color',
}
